import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Registro Asistencias
                </h2>
                <p>
                    Registra las entradas y salidas de un alumnos
                </p>
            </div>
        </div>
    );
};

export default Header;